<template>
    <section class="containerg plata_card_response_section">
        <div class="title_politica">{{ $t('comanda_refuzata') }}</div>
        <div class="container_politica">
                Plata a fost refuzata.
                <a @click='goToCheckout()'>Reincearca plata</a>
        </div>      
    </section>
</template>
<script>
  export default {
    mounted () {
        if (window.location.href.indexOf("error?t=") > -1) {
            var url_string = window.location.href;
            var url = new URL(url_string);
            var s = url.searchParams.get("s");
            this.checkout_id = s;   
        }
        else
        {
            this.$router.push({ name: '404' })
        }
    },
    methods: {
        goToCheckout() {
            window.location.replace('https://www.vivapayments.com/web/checkout?ref='+this.checkout_id);
        }
    }
  }
</script>
